export const reviewDataSelector = (state: any) => state.review.data;
export const requestMessageSelector = (state:any) => state.review.message;
export const APIRequestStatusSelector = (state: any) => state.review.requestStatus;
export const reviewStatusSelector = (state: any) => state.review.data.status;
export const canMergeReviewSelector = (state:any) => state.review.data.canMerge;
export const ownerSelector = (state: any) => state.review.data.owner;
export const basicDescriptionSelector = (state: any) => state.review.data.descriptionInfo.basicDescription;
export const sourceContentSelector = (state: any) =>state.review.data.sourceContent;
export const changeContentSelector = (state: any) =>state.review.data.changeContent;
